import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  MERCHANT_LOGIN_REQUEST,
  MERCHANT_LOGIN_SUCCESS,
  MERCHANT_LOGIN_FAILURE,
  LOGOUT,
  PASSWORD_CHANGE_REQUEST,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  DELETE_ACCOUNT_REQUEST,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAILURE,
  CONFIRM_PASSWORD_REQUEST,
  CONFIRM_PASSWORD_SUCCESS,
  CONFIRM_PASSWORD_FAILURE,

} from '../actions/types';

const initialState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null,
  passwordChangeLoading: false,
  passwordChangeError: null,
  passwordChangeSuccess: null,
  otpVerifying: false,
  otpError: null,
  otpSuccess: null,
  deleteAccountLoading: false,
  deleteAccountError: null,
  deleteAccountSuccess: null,
  confirmPasswordLoading: false,
  confirmPasswordError: null,
  confirmPasswordSuccess: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        loading: false,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case MERCHANT_LOGIN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case MERCHANT_LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        loading: false,
        error: null,
      };

    case MERCHANT_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        error: null,
      };

    //Password Change
    case PASSWORD_CHANGE_REQUEST:
      return {
        ...state,
        passwordChangeLoading: true,
        passwordChangeError: null,
        passwordChangeSuccess: null,
      };
    case PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
        passwordChangeLoading: false,
        passwordChangeSuccess: action.payload,
        passwordChangeError: null,
      };
    case PASSWORD_CHANGE_FAILURE:
      return {
        ...state,
        passwordChangeLoading: false,
        passwordChangeError: action.payload,
        passwordChangeSuccess: null,
      };

    //OTP Verification
    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        otpVerifying: true,
        otpError: null,
        otpSuccess: null,
      };
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        otpVerifying: false,
        otpSuccess: action.payload,
        otpError: null,
      };
    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        otpVerifying: false,
        otpError: action.payload,
        otpSuccess: null,
      };

    //Delete Account
    case DELETE_ACCOUNT_REQUEST:
      return {
        ...state,
        deleteAccountLoading: true,
        deleteAccountError: null,
        deleteAccountSuccess: null,
      };
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deleteAccountLoading: false,
        deleteAccountSuccess: action.payload,
        deleteAccountError: null,
      };
    case DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        deleteAccountLoading: false,
        deleteAccountError: action.payload,
        deleteAccountSuccess: null,
      };

    //Confirm Password
    case CONFIRM_PASSWORD_REQUEST:
      return {
        ...state,
        confirmPasswordLoading: true,
        confirmPasswordError: null,
        confirmPasswordSuccess: null,
      };
    case CONFIRM_PASSWORD_SUCCESS:
      return {
        ...state,
        confirmPasswordLoading: false,
        confirmPasswordSuccess: action.payload,
        confirmPasswordError: null,
      };
    case CONFIRM_PASSWORD_FAILURE:
      return {
        ...state,
        confirmPasswordLoading: false,
        confirmPasswordError: action.payload,
        confirmPasswordSuccess: null,
      };


    default:
      return state;
  }
};

export default authReducer;
